import React, { useCallback } from 'react';
import { StyleSheet, View } from 'react-native';
import Button from 'design-system/Button';
import Modal from 'utils/packages/Modal';
import Spacer from 'design-system/Spacer';
import Text from 'design-system/Text';
import { rem } from 'design-system/values';
import links from 'utils/links';
const TestflightInfoModalContent = () => {
    const handlePress = useCallback(() => {
        links.openEmmaInAppStore();
        Modal.hide();
    }, []);
    return (<View style={styles.container}>
      <View style={styles.textContainer}>
        <Text TextThin-14 Secondary centered>
          Download the latest version of Emma from the App Store to upgrade your
          account.
        </Text>
      </View>
      <Spacer h={40}/>
      <Button brand title="Get the latest version" onPress={handlePress}/>
    </View>);
};
export const TestflightInfoModal = {
    show: () => {
        Modal.show(<TestflightInfoModalContent />, {
            containerStyle: styles.modal,
            title: 'You are on Testflight',
        });
    },
    hide: () => {
        Modal.hide();
    },
};
const styles = StyleSheet.create({
    modal: {
        paddingHorizontal: 0,
        overflow: 'hidden',
    },
    container: {
        paddingHorizontal: rem(16),
    },
    textContainer: {
        paddingVertical: rem(8),
    },
});
